import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LinkService {
  // private link: HTMLLinkElement;

  constructor(
      @Inject(DOCUMENT) private doc,
      @Inject(PLATFORM_ID) private platformId,
  ) {
  }

  // createLinkForCanonicalURL(): void {
    // if (!isPlatformBrowser(this.platformId)) {
      // if (this.link === undefined) {
       // this.link = this.doc.createElement('link');
        // this.link.setAttribute('rel', 'canonical');
        // this.doc.head.appendChild(this.link);
      // }
      // this.link.setAttribute('href', this.doc.URL.split('?')[0]);
    // }
  // }

  public insertingRobots(): void {
    if (!isPlatformBrowser(this.platformId)){
      if (this.doc.URL.includes('hml')){
        const meta = this.doc.createElement('meta');
        meta.name = 'robots';
        meta.content = 'noindex, nofollow';
        this.doc.head.appendChild(meta);
      }
    }
  }
}
